import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

type messageType = "loading" | "info"

@Component({
  selector: 'esc-message-info-overlay',
  templateUrl: './message-info-overlay.component.html',
  styleUrls: ['./message-info-overlay.component.scss']
})
export class MessageInfoOverlayComponent implements OnInit {

  @Input() icon = "cloud-alert"
  @Input() title = "No Internet Connection";
  @Input() message = "Please check your internet connection and try again.";
  @Input() btnMessage = "Retry";
  @Input() enableBtn = true;
  @Input() messageType: messageType = "info"
  @Output() btnFn = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  retry() {
    this.btnFn.emit();
  }

}
